<template>
  <div class="v-page-switcher__wrapper">
    <span> Page </span>
    <div class="v-page-switcher__input-wrapper">
      <input
        v-model="currentPage"
        type="number"
        name="currentPage"
        ref="currentPage"
        class="currentPage"
        min="1"
        :max="currentPage || 1"
        :style="{ width: inputWidth }"
        @input="inputChange"
        @blur="onBlur"
        @keyup.enter="pageChange"
        @keypress="filterInput"
      />
    </div>

    <button @click="pageChange">Go <i class="far fa-chevron-right"></i></button>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

import withToasted from "@/mixins/withToasted";

export default Vue.component("VPageSwitcher", {
  props: {
    totalItems: VueTypes.number.def(1),
    itemsPerPage: VueTypes.number.def(10),
    totalPages: VueTypes.number
  },

  mixins: [withToasted],

  data() {
    return {
      currentPage: 1,
      prevPage: 1
    };
  },

  methods: {
    pageChange() {
      this.$emit("change", Number(this.currentPage));
    },

    filterInput(e) {
      const keyCode = e.keyCode ? e.keyCode : e.which;
      if (keyCode < 47 || keyCode > 58) {
        e.preventDefault();
        e.stopPropagation();
      }
    },

    onBlur() {
      if (this.currentPage === "") {
        this.currentPage = this.prevPage;
      }
    },

    inputChange(e) {
      const { value } = e.target;

      if (Number(value) === 0 && value !== "") {
        this.currentPage = this.prevPage;
        this.toast(`Page must be a positive value`, "error", {
          duration: 4000,
          position: "top-right"
        });
      }

      if (Number(value) > this.pagesCount) {
        this.currentPage = this.prevPage;
        this.toast(`Page #${value} doesn't exist`, "error", {
          duration: 4000,
          position: "top-right"
        });
      } else if (this.currentPage !== "") {
        this.prevPage = this.currentPage;
      }
    }
  },

  computed: {
    inputWidth() {
      // set default value for input
      if (this.currentPage === "") {
        return "12px";
      }

      return `${this.currentPage.toString().length * 12}px`;
    },

    pagesCount() {
      return this.totalPages
        ? this.totalPages
        : Math.ceil(this.totalItems / this.itemsPerPage);
    }
  }
});
</script>

<style lang="scss" scoped>
$ns: "v-page-switcher";
.#{$ns} {
  &__wrapper {
    display: flex;
    align-items: center;
    color: $secondary-text-color;

    &,
    button,
    span {
      font-family: Lato-Medium, sans-serif;
    }

    button {
      font-size: 14px;
      border: 1px solid transparent;
      cursor: pointer;
      border-radius: 3px;
      transition: background-color 0.1s linear;
      outline: none;
      font-weight: 400;
      display: flex;
      align-items: center;
      background: transparent;
      padding: 0;
      color: $secondary-text-color;

      i {
        margin-left: 10px;
        font-size: 13px;
        color: $primary-grey;
      }

      &:hover {
        &,
        i {
          color: $primary-color;
        }
      }
    }
  }

  &__input-wrapper {
    border-radius: 4px;
    border: 1px solid $primary-grey;
    margin: 0 15px;
    transition: color 0.2s linear;
    height: 32px;
    width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;

    input[type="number"] {
      color: $secondary-text-color;
      min-width: 32px;
      height: 32px;
      font-size: 12px;
      background: transparent;
      outline: none;
      -moz-appearance: textfield;
      width: 100%;
      text-align: center;
      cursor: pointer;
      padding: 0;
      border: none;

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }

    &:hover,
    &:focus-within {
      border-color: $primary-color;
    }
  }
}
</style>
